<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
    import * as API from "./api"

    export default {
        name: "tender",
        components: {},
        data() {
            return {}
        },
        mounted() {

        },
        methods: {},
    }
</script>

<style lang="scss" scoped>

</style>